import { getQueryParamValueByKey } from "../../../utils/queryParams";

export default {
    install(Vue, options) {
        Vue.prototype.$getQueryParamValueByKey = function(queryParams, queryKey, multiValueFilter = false) {
            let queryValue = getQueryParamValueByKey(queryParams, queryKey);

            if (!queryValue) return;

            if (multiValueFilter) queryValue = queryValue.split(",");

            return queryValue;
        };
    },
};
